<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('wholesaleReceipt.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('wholesaleReceipt.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div
          class="d-flex justify-content-between ts-items-center ts-whitespace-no-wrap ts-space-x-3"
        >
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width: 200px"
              @change="fetchData()"
            />
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-input
              v-tooltip="$t('wholesaleReceipt.search')"
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('wholesaleReceipt.branchName') }}</label>
                  <ts-branch-filter
                    @filter="branchFilter" 
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'payment_date',
          }"
        >
          <template v-slot="{ record }">
            <td>{{ record.branch.branch_name_en }}</td>
            <td class="ts-whitespace-no-wrap">
              {{ record.receipt_no }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.invoice_no }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.customer_name }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.invoice_amount }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.amount_paid }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.amount_due }}</td>
            <td class="ts-whitespace-no-wrap">
              <span
                :class="
                  record.next_payment_date
                    ? 'ts-px-3 ts-rounded-md ts-bg-pink-600 ts-text-white ts-font-bold'
                    : ''
                "
                >{{ record.next_payment_date }}</span
              >
            </td>
            <td class="ts-whitespace-no-wrap ts-text-center">
                {{ record.payment_status }}
            </td>
            <td class="ts-whitespace-no-wrap">
               {{ record.sale_name}}
            </td>
            <td>
              {{ record.cashier_name }}
            </td>
            <td class="text-center ts-space-x-3">
              <a
                href="#"
                v-tooltip="$t('quotation.reprint')"
                class="text-primary"
                @click.prevent="reprintReport(record)"
              >
                <i class="fas fa-print"></i>
              </a>
              <!-- <a
                v-if="record.allow_pay && record.amount_due > 0"
                href="#"
                v-tooltip="$t('wholesaleReceipt.receipt')"
                class="text-warning"
                @click.prevent="receiptPayment(record)"
              >
                <i class="fas fa-receipt"></i>
              </a> -->
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
      <a-modal
        v-if="wholesalereceipt"
        v-model="wholesalereceipt"
        :title="$t('wholesaleReceipt.receipt')"
        :footer="null"
        width="60%"
        @cancel="onCancel"
      >
        <Receipt :record="receipt_data" @cancel="onCancel" />
      </a-modal>
      <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
        <ts-preview-pdf v-model="waiting" :src="src" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import Receipt from './components/payment-receipt'
import Reason from './components/reason_delete.vue'

export default {
  name: 'wholesaleReceipt',
  components: {
    Receipt,
  },
  data() {
    return {
      loading: false,
      waiting: false,
      src: null,
      receipt_data: {},
      wholesalereceipt: false,
      show_pdf: false,
      model: {
        deleted_reason: null,
      },
      errors: new Errors(),
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('wholesale/receipt', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.wholesale.receipt.search
      },
      set(newValue) {
        this.$store.commit('wholesale/receipt/SET_SEARCH', newValue)
        this.$store.commit('wholesale/receipt/RESET_CURRENT_PAGE')
      },
    },
    dateRange: {
      get() {
        return this.$store.state.wholesale.receipt.dateRange
      },
      set(newValue) {
        this.$store.commit('wholesale/receipt/SET_DATE_RANGE', newValue)
      },
    },
    columns() {
      return [
        { name: this.$t('wholesaleReceipt.branchName') },
        { name: this.$t('wholesaleReceipt.receiptNo') },
        { name: this.$t('wholesaleReceipt.invoiceNo') },
        { name: this.$t('wholesaleReceipt.customer') },
        { name: this.$t('wholesaleReceipt.invoiceAmount') },
        { name: this.$t('wholesaleReceipt.amountPaid') },
        { name: this.$t('wholesaleReceipt.amountDue') },
        { name: this.$t('wholesaleReceipt.nextPayment') },
        { name: this.$t('wholesaleReceipt.paymentStatus') },
        { name: this.$t('wholesaleReceipt.saleName') },
        { name: this.$t('wholesaleReceipt.cashierName') },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:7%',
        },
      ]
    },
  },
  methods: {
    addNew() {
      this.$router.push({ name: 'wholesale-receipt-create' })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('wholesale/receipt/fetch', { ...attributes })
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    deleteRecord(record) {
      this.model.deleted_reason = null
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        content: (h) =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('wholesale.leaveReason'),
            },
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.$store
            .dispatch('wholesale/receipt/destroy', {
              id: record.receipt_id,
              data: this.model,
            })
            .then((response) => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch((error) => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel() {},
      })
    },
    receiptPayment(record) {
      this.wholesalereceipt = true
      this.src = ''
      this.receipt_data = record
    },
    onCancel() {
      this.fetchData()
      this.wholesalereceipt = false
    },
    reprintReport(record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('wholesale/receipt/reprint', record.receipt_id)
        .then((response) => {
          this.src = response.url
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    branchFilter(value){
      this.$store.commit('wholesale/receipt/SET_BRANCH_ID', value)
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/receipt/RESET_STATE')
    next()
  },
}
</script>